export const firstYearOfDevelopment: number = 2018
// export const ContentTransparent = require('./content-transparent.png')
export const zollar = require('./zollar2.svg')
export const zero = require('./0.png')
export const zeroPng: string =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII='
// export const logo = require('./tour-logo-white.png')
// export const bezt = require('./Beztbetlogo.png')
// export const logo2 = require('./tour-logo-transp.png')

export const cancel: string = 'fa fa-times'
export const cancelCircle: string = 'fa fa-times-circle-o'
export const productName: string = 'Accumulator Club'
export const productOwner: string = 'Fair Play Gaming Ltd'
export const productYear: string = '2018'
export const productSource: string = 'Premier League'
export const supportMail: string = 'support@accumulatorclub.com'
export const contactMail: string = 'support@accumulatorclub.com'

export const loaderImage = require('../assets/img/loader.gif')

export const logoMain = require('./img/logo-main.png')
export const poweredByGamanzaBlack = require('./img/powered-by-gamanza-black.svg')
export const poweredByGamanzaWhite = require('./img/powered-by-gamanza-white.svg')

export const enum location {
    firstPage = 1, contact, howtoplay, terms, privacy, lounge, results, betStep1, betStep2, betStep3, confirmation, 
    login, registration, leaderboards, leagues, myprofile
}

export enum CompetitionTypes {
    League = 1,
    HomeCups,
    InternationalCups,
    International,
}

export type Menu = {
    content: string
    selector?: number
}

export type StringContent = {
    content: string[],
}

export const menuLeft: Menu[] = [
    {content: 'LOUNGE', selector: location.login},
    {content: 'HOW TO PLAY'},
    {content: 'LEAGUES', selector: location.login}
]

export const homeMenuLeft: Menu[] = [
    {content: 'LOUNGE', selector: location.login},
    {content: 'HOW TO PLAY'}
]

export const mobileMenuLeft: Menu[] = [
    {content: 'LOUNGE', selector: location.login},
    {content: 'HOW TO PLAY'},
    {content: 'LEAGUES', selector: location.login},
    {content: 'MY PROFILE', selector: location.myprofile},
    {content: 'LOGOUT', selector: location.login}
]

export const mobileMenuLeftLogin: Menu[] = [
    {content: 'LOUNGE', selector: location.login},
    {content: 'HOW TO PLAY'},
    {content: 'LEAGUES', selector: location.login},
    {content: 'LOGIN', selector: 100},
    {content: 'SIGN UP', selector: 100}
]

export const menuRight: Menu [] = [
    {content:'LOGIN', selector: location.login},
    {content:'SIGN UP', selector: location.registration},
]

export const homeMenuRight: Menu [] = [
    {content: 'LEAGUES', selector: location.login},
    {content:'LOGIN', selector: location.login},
    {content:'SIGN UP', selector: location.registration},
]

export const About: Menu[] = [
    {content: 'Contact', selector: location.contact},
    {content: 'How to Play', selector: location.howtoplay}
]

export const Help: Menu[] = [
    {content: 'Terms and Conditions', selector: location.terms},
    {content: 'Privacy Policy', selector: location.privacy}
]

export const NewFormat: StringContent = {content: [
    'The Accumulator Club is an exciting new game format and a fresh take on football predictions. Predict the final score of any five of the weekly fixtures, place a 4-fold accumulator on any four fixtures to feature BTTS, Over/Under 2.5 goals or a draw, then pick out three anytime goalscorers and two card indexes.',
    'Wear out the edge of your seat as your predictions and selections earn points according to the real action!'
    ]
}

export const PrivateLeagues: StringContent = {content: [
    'It’s quick and easy to setup a private league and invite friends, colleagues or teammates, just like the Fantasy Premier League.',
    'You will automatically compete for the weekly and overall number 1 ranking, but nothing beats the enjoyment of the classic bants between your nearest and dearest, or punishing the local David Brent at the office.'
    ]
}

export const OriginalContent: StringContent = {content: [
    'We love football, we love talking about it, watching it, arguing about it and writing about it. Our news and blog page is frequently updated with team and player information, weekly previews, betting tips, fantasy football insight and other football related stuff.',
    'But it’s not all about our views and observations - We’re no experts and everyone has an opinion, so we encourage you to voice it!'
    ]
}




// WEBPACK FOOTER //
// ./src/assets/Assets.ts